import React from "react";
import { useAppScope } from "master/contexts";
import { Login, LoginMWCD } from ".";

export const LoginGateway = () => {
  const { isMWCD } = useAppScope();
  if (isMWCD) return <LoginMWCD />;
  return <Login />;
};
